import { useBrokersServiceBrokersBrokersMediaList } from '@insurance/api/queries'
import { BrokerMedia } from '@insurance/api/requests'
import { TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import { AddMediaButton, MediaHeader, MediaTable } from '../components'

type Props = {
  brokerId: string
}

export const MediaPage = ({ brokerId }: Props) => {
  const { t } = useTranslation()

  const { params, updateQuery } = useQueryUpdate()
  const { triggerSort, getSortedTableColumns } = useSorting<BrokerMedia>()

  const { data, isLoading } = useBrokersServiceBrokersBrokersMediaList({
    ...params,
    broker: Number(brokerId)
  })

  return (
    <>
      <TitleSection
        title={t('files')}
        count={data?.count}
        isLoading={isLoading}
      >
        <MediaHeader />
      </TitleSection>

      <Flex vertical gap={16}>
        <Flex justify="end" gap={16} wrap>
          <AddMediaButton broker={Number(brokerId)} />
        </Flex>

        <MediaTable
          broker={Number(brokerId)}
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page, pageSize) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
